/* eslint-disable max-lines */
import { Box, Grid, Typography } from '@mui/material';
import { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import EliteImage from '../../../images/EliteAccImg1.png';
import LeadGenerationContext from '../../../context/LeadGenerationContext';
import DocumentUploadSidebar from '../../Sidebar/DocumentUploadSidebar';
import { saveAddressInformation } from '../../../services/formService';
import { AddressInformationStyles as classes, formHeadingInfo } from './AddressInformationStyles';
import { productNameURLMapping } from '../../../services/productNameURLMapping';
import HomeAddress from './HomeAddress';
import MailingAddress from './MailingAddress';
import { dgiMapping } from '../../../services/dgiMapping';
import {
  ADDRESS_INFO_HEAD,
  ADDRESS_INFO_HEAD_PROG,
  CHANGE_ADDRESS,
  DIFFERENT_MAIL_ADDR,
  DONE,
  ELITE_ACCOUNT_EN,
  FAILED,
  HOME_ADDRESS_TITLE,
  HOME_ADDRESS_TITLE_PROG,
  HOME_PR,
  HOME_VI,
  INVALID_FORMAT_ERR,
  LIBRE_AHORRA_BUNDLE,
  MAIL_ADDRESS,
  MAIL_HOME_ADDR_SAME,
  MANDATORY_FIELD_ERR,
  MSG_VOUCHED_MODAL,
  VALIDATION_BACKSPACE,
  VERIFICATION_COMPLETED,
} from '../../../constants';
import { productMapping } from '../../../services/productMapping';
import { tooltipMailingText, tooltipStyle } from './AddressInformationUtils';
import CustomTooltip from '../../Tooltip/CustomTooltip';
import CustomSwitch from '../Switch/CustomSwitch';
import { commonUtility, commonUtilityValueReturn } from '../UtilityFunctions';
import RetailImage1 from '../../../images/Retail_Image_1.png';
import {
  clearOCRdata,
  clearUploadFocus,
  commonTernary,
  handleAddressEditModal,
  isBundle,
  vouchedJobCallForFraudCheck,
} from '../../commonCode';
import AddressEditModal from '../../Modal/AddressEditModal';
import SaveAppContactInfo from '../../SaveApp/SaveAppContactInfo';
import Layout from '../../Layout';
import CommercialModal from '../../CommercialDeposit/CommercialModal';
import NewLayout from '../../Bundle/NewLayout';
import AddressInfo from '../../Bundle/AddressInfo';
import BillTypeCustomCard from '../../Bundle/BillTypeCustomCard';
import { LayoutStyles as layoutClasses } from '../../Bundle/LayoutStyles';
import { GreenTick } from '../../../images/svg/CustomizedSVG';
import VouchedFailed from '../../Bundle/VouchedFailed';

/** AddressInformation is the parent comp rendered as a screen 3 for normal account opening process and dgi product flow
 child comps are HomeAddress, MailingAddress, DocumentUploadSidebar */

const AddressInformation = (props) => {
  const { t } = useTranslation();
  const leadGenerationContext = useContext(LeadGenerationContext);

  const [isValidating, setIsValidating] = useState(false);

  const { history } = props;

  const {
    addressInformation,
    setAddressInformation,
    addressInformationErrors,
    setAddressInformationErrors,
    isScreenThreeDirty,
    setIsScreenThreeDirty,
    setIsScreenFourDirty,
    setIsScreenFiveDirty,
    setIsTrustInfoDirty,
    setIsFundingScreenDirty,
    setIsFinanceInfoDirty,
    setIsEdeliveryScreenDirty,
    setCurrentPage,
    location,
    language,
    productName,
    personalInformation,
    addressProofUploadStatus,
    ocrResponse,
    isModalSaveLater,
    ocrErrorMessageArr,
    setOcrResponse,
    newAddress,
    addressWithErrors,
    addressEditQuestionModal,
    setAddressEditQuestionModal,
    setIsModalSaveLater,
    userOptionAddress,
    vouchedJob,
    vouchedFailModal,
    vouchedResponseAddr,
    disableContinue,
    setIsFullAddressEdited,
    setPopupModalIntial,
    theme,
    isLightTheme,
    contactInformation,
  } = leadGenerationContext;

  useEffect(() => {
    setCurrentPage('address-info');
  }, []);

  useEffect(() => {
    if (Object.keys(vouchedResponseAddr).length === 0 && vouchedJob !== null) {
      vouchedJobCallForFraudCheck(setIsValidating, leadGenerationContext);
    }
  }, []);

  useEffect(() => {
    const { address1, address2, city, state, zipCode, country } = addressInformation;

    setAddressInformation((prevState) => ({
      ...prevState,
      fullAddress: `
      ${commonUtilityValueReturn(address1, `${address1}, `, '')}${commonUtilityValueReturn(
        address2,
        `${address2}, `,
        ''
      )}${commonUtilityValueReturn(city, `${city}, `, '')}${commonUtilityValueReturn(
        state !== 'N/A',
        `${state}, `,
        ''
      )}${commonUtilityValueReturn(zipCode, `${zipCode}, `, '')}${commonUtilityValueReturn(
        country,
        `${country} `,
        ''
      )} `,
    }));

    if (address1?.length > 30) {
      setAddressInformationErrors((prevState) => ({
        ...prevState,
        address1: '* Address Line 1 should have max 30 characters.',
      }));
    } else if (address1?.length > 0) {
      if (address1.match(/^[A-Za-z0-9'#@%&\\/.\-\s,]+$/) && address1.length >= 2) {
        setAddressInformationErrors((prevState) => ({
          ...prevState,
          address1: '',
        }));
      } else {
        setAddressInformationErrors((prevState) => ({
          ...prevState,
          address1: '* Invalid address',
        }));
      }
    }
    if (address2?.length > 30) {
      setAddressInformationErrors((prevState) => ({
        ...prevState,
        address2: '* Address Line 2 should have max 30 characters.',
      }));
    } else if (address2?.length > 0) {
      if (address2.match(/^[A-Za-z0-9'#@%&\\/.\-\s,]+$/) && address2.length >= 2) {
        setAddressInformationErrors((prevState) => ({
          ...prevState,
          address2: '',
        }));
      } else {
        setAddressInformationErrors((prevState) => ({
          ...prevState,
          address2: '* Invalid address',
        }));
      }
    }
  }, [addressInformation.address1, addressInformation.address2]);

  const uploadFocus = () => {
    let element = '';
    element = document.getElementById('uploadContainer');

    if (element) {
      if (isBundle(productName)) {
        if (!isLightTheme) {
          element.setAttribute(
            'style',
            'background-image: repeating-linear-gradient(0deg,#D0D0D0,#D0D0D0 7px,transparent 8px,transparent 15px),repeating-linear-gradient(90deg,#D0D0D0,#D0D0D0 7px,transparent 8px,transparent 15px),repeating-linear-gradient(180deg,#D0D0D0,#D0D0D0 7px,transparent 8px,transparent 15px),repeating-linear-gradient(270deg,#D0D0D0,#D0D0D0 7px,transparent 8px,transparent 15px) !important; background-size: 1px 100%, 100% 1px, 1px 100%, 100% 1px;background-repeat: no-repeat;background-position: 0 0, 0 0, 100% 0, 0 100%'
          );
        } else {
          element.setAttribute(
            'style',
            'background-image: repeating-linear-gradient(0deg,#D0D0D0,#D0D0D0 7px,transparent 8px,transparent 15px),repeating-linear-gradient(90deg,#D0D0D0,#D0D0D0 7px,transparent 8px,transparent 15px),repeating-linear-gradient(180deg,#D0D0D0,#D0D0D0 7px,transparent 8px,transparent 15px),repeating-linear-gradient(270deg,#D0D0D0,#D0D0D0 7px,transparent 8px,transparent 15px) !important;background-size: 1px 100%, 100% 1px, 1px 100%, 100% 1px;background-repeat: no-repeat;background-position: 0 0, 0 0, 100% 0, 0 100%'
          );
        }
      } else {
        element.setAttribute(
          'style',
          'background-image: repeating-linear-gradient(0deg,#D71721,#D71721 7px,transparent 8px,transparent 15px),repeating-linear-gradient(90deg,#D71721,#D71721 7px,transparent 8px,transparent 15px),repeating-linear-gradient(180deg,#D71721,#D71721 7px,transparent 8px,transparent 15px),repeating-linear-gradient(270deg,#D71721,#D71721 7px,transparent 8px,transparent 15px) !important; background:#FFF2F2;background-size: 1px 100%, 100% 1px, 1px 100%, 100% 1px;background-repeat: no-repeat;background-position: 0 0, 0 0, 100% 0, 0 100%'
        );
      }
    }
  };

  const handleChangeZipcode = (e) => {
    if (e.target?.value?.match(/^\d+$/) || e.key === VALIDATION_BACKSPACE) {
      setAddressInformation((prevState) => ({ ...prevState, [e.target.name]: e.target.value }));
      setAddressInformationErrors((prevState) => ({ ...prevState, [e.target.name]: '' }));
      if (e.target.name === 'zipCode' && addressInformation?.sameMailingAddress) {
        setAddressInformation((prevState) => ({
          ...prevState,
          permanentZipCode: e.target.value,
        }));
      }
      if (e.target.value.length < 5) {
        setAddressInformationErrors((prevState) => ({
          ...prevState,
          [e.target.name]: '* Zipcode should have 5 digits',
        }));
      } else if (e.target.value?.match(/^0*$/g)) {
        setAddressInformationErrors((prevState) => ({
          ...prevState,
          [e.target.name]: '* Please enter a valid zipcode',
        }));
      } else {
        setAddressInformationErrors((prevState) => ({ ...prevState, [e.target.name]: '' }));
      }
    } else if (e.target.value === '') {
      setAddressInformation((prevState) => ({ ...prevState, [e.target.name]: '' }));
      setAddressInformationErrors((prevState) => ({
        ...prevState,
        [e.target.name]: MANDATORY_FIELD_ERR,
      }));
    } else {
      setAddressInformation((prevState) => ({ ...prevState, [e.target.name]: e.target.value }));
      setAddressInformationErrors((prevState) => ({
        ...prevState,
        [e.target.name]: INVALID_FORMAT_ERR,
      }));
    }
  };

  const handleChangeCity = (e) => {
    if (e.target.value && e.target.value.length > 0) {
      setAddressInformation((prevState) => ({ ...prevState, [e.target.name]: e.target.value }));
      setAddressInformationErrors((prevState) => ({ ...prevState, [e.target.name]: '' }));
      if (e.target.name === 'city' && addressInformation?.sameMailingAddress) {
        setAddressInformation((prevState) => ({ ...prevState, permanentCity: e.target.value }));
      }
    } else {
      setAddressInformation((prevState) => ({
        ...prevState,
        [e.target.name]: e.target.value ? e.target.value : '',
      }));
      setAddressInformationErrors((prevState) => ({
        ...prevState,
        [e.target.name]: MANDATORY_FIELD_ERR,
      }));
    }
  };
  const handlechnagecity = (e, isMailing) => {
    setAddressInformation((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value ? e.target.value : '',
      [isMailing ? 'permanentCity' : 'city']: '',
    }));
    setAddressInformationErrors((prevState) => ({
      ...prevState,
      [e.target.name]: MANDATORY_FIELD_ERR,
    }));
  };
  const handleChangeState = (e) => {
    const isMailing = e.target.name === 'permanentState';
    if (e.target.value && e.target.value.length > 0) {
      setAddressInformation((prevState) => ({
        ...prevState,
        [e.target.name]: e.target.value,
        [isMailing ? 'permanentCity' : 'city']: '',
      }));
      setAddressInformationErrors((prevState) => ({
        ...prevState,
        [e.target.name]: '',
        [isMailing ? 'permanentCity' : 'city']: '',
      }));
      if (e.target.name === 'state' && addressInformation?.sameMailingAddress) {
        setAddressInformation((prevState) => ({
          ...prevState,
          permanentState: e.target.value,
        }));
      }
    } else {
      handlechnagecity(e, isMailing);
    }
  };
  const handlechangecountry = (e, isMailing) => {
    setAddressInformation((prevState) => ({
      ...prevState,
      zipCode: '',
      [e.target.name]: e.target.value ? e.target.value : '',
      [isMailing ? 'permanentState' : 'state']:
        e.target.value === 'PR' || e.target.value === 'VI' ? 'N/A' : '',
      [isMailing ? 'permanentCity' : 'city']: '',
    }));
    setAddressInformationErrors((prevState) => ({
      ...prevState,
      [e.target.name]: MANDATORY_FIELD_ERR,
    }));
  };
  const handlecountry = (e, isMailing) => {
    setAddressInformation((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
      [isMailing ? 'permanentState' : 'state']:
        e.target.value === 'PR' || e.target.value === 'VI' ? 'N/A' : '',
      [isMailing ? 'permanentCity' : 'city']: '',
    }));
    setAddressInformationErrors((prevState) => ({
      ...prevState,
      [e.target.name]: '',
      [isMailing ? 'permanentState' : 'state']: '',
      [isMailing ? 'permanentCity' : 'city']: '',
    }));
  };
  const handleChangeCountry = (e) => {
    const isMailing = e.target.name === 'permanentCountry';
    if (e.target.value && e.target.value.length > 0) {
      handlecountry(e, isMailing);
      if (e.target.name === 'country' && addressInformation?.sameMailingAddress) {
        setAddressInformation((prevState) => ({
          ...prevState,
          zipCode: '',
          permanentCountry: e.target.value,
          permanentState: e.target.value === 'PR' || e.target.value === 'VI' ? 'N/A' : '',
        }));
      }
    } else {
      handlechangecountry(e, isMailing);
    }
  };
  const handleChangeBillType = (e) => {
    clearOCRdata(leadGenerationContext);
    setAddressInformation((prevState) => ({ ...prevState, ocrAddressVerified: false }));
    setAddressInformation((prevState) => ({ ...prevState, ocrAddressEdit: false }));
    setAddressInformation((prevState) => ({ ...prevState, homeAddressUploadDocumentId: null }));
    setOcrResponse(false);
    if (e.target.value && e.target.value.length > 0) {
      setAddressInformation((prevState) => ({
        ...prevState,
        [e.target.name]: e.target.value,
      }));
      setAddressInformationErrors((prevState) => ({
        ...prevState,
        [e.target.name]: '',
      }));
      if (e.target.name === 'utilityBill') {
        setAddressInformation((prevState) => ({
          ...prevState,
          utilityBill: e.target.value,
        }));
        uploadFocus();
      }
    } else {
      setAddressInformation((prevState) => ({
        ...prevState,
        [e.target.name]: e.target.value ? e.target.value : '',
      }));
      setAddressInformationErrors((prevState) => ({
        ...prevState,
        [e.target.name]: MANDATORY_FIELD_ERR,
      }));
      clearUploadFocus();
    }
  };
  const addressInformationChange = (e) => {
    if (
      e.target.value.match(/^[A-Za-z0-9'#@%&\\/.\-\s,]+$/) &&
      e.target.value?.length >= 2 &&
      e.target.value.length <= 30
    ) {
      setAddressInformation((prevState) => ({ ...prevState, [e.target.name]: e.target.value }));
      setAddressInformationErrors((prevState) => ({ ...prevState, [e.target.name]: '' }));
      if (e.target.name === 'address2' && addressInformation?.sameMailingAddress) {
        setAddressInformation((prevState) => ({
          ...prevState,
          permanentAddress2: e.target.value,
        }));
      }
    } else if (e.target.value.length > 30) {
      setAddressInformation((prevState) => ({ ...prevState, [e.target.name]: e.target.value }));
      setAddressInformationErrors((prevState) => ({
        ...prevState,
        [e.target.name]: '* Address Line 2 should have max 30 characters.',
      }));
    } else {
      setAddressInformation((prevState) => ({ ...prevState, [e.target.name]: e.target.value }));
      setAddressInformationErrors((prevState) => ({
        ...prevState,
        [e.target.name]: '* Invalid address',
      }));
    }
  };
  const handleChangeAddresstwo = (e) => {
    if (e.target.value && e.target.value.length > 0) {
      addressInformationChange(e);
    } else {
      if (e.target.name === 'address2' && addressInformation?.sameMailingAddress) {
        setAddressInformation((prevState) => ({
          ...prevState,
          permanentAddress2: e.target.value,
        }));
      }
      const { value } = e.target;
      setAddressInformation((prevState) => ({ ...prevState, [e.target.name]: value || '' }));
      setAddressInformationErrors((prevState) => ({ ...prevState, [e.target.name]: '' }));
    }
  };
  const handleChangeMailingAddress = (e) => {
    const defaultCountry = addressInformation?.defaultCountryBasedOnLocation;
    setAddressInformation((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.checked,
      permanentAddress1: '',
      permanentAddress2: '',
      permanentCity: '',
      permanentCountry: defaultCountry,
      permanentState: defaultCountry === 'VI' || defaultCountry === 'PR' ? 'N/A' : '',
      permanentZipCode: '',
    }));
  };
  const handleChangeMailing = (e) => {
    setAddressInformation((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.checked,
      permanentAddress1: prevState?.address1 ? prevState.address1 : '',
      permanentAddress2: prevState?.address2 ? prevState.address2 : '',
      permanentCity: prevState?.city ? prevState.city : '',
      permanentCountry: prevState?.country,
      permanentState: prevState?.state,
      permanentZipCode: prevState?.zipCode ? prevState.zipCode : '',
    }));
    setAddressInformationErrors((prevState) => ({
      ...prevState,
      permanentAddress1: '',
      permanentAddress2: '',
      permanentCity: '',
      permanentCountry: '',
      permanentState: '',
      permanentZipCode: '',
    }));
  };
  const handleDirty = () => {
    setIsScreenThreeDirty(true);
    setIsTrustInfoDirty(true);
    setIsFinanceInfoDirty(true);
    setIsFundingScreenDirty(true);
    setIsEdeliveryScreenDirty(true);
  };

  const handleChangeDirty = () => {
    setIsScreenThreeDirty(true);
    setIsScreenFourDirty(true);
    setIsScreenFiveDirty(true);
    setIsFundingScreenDirty(true);
  };
  const handleCallDirty = () => {
    if (dgiMapping(leadGenerationContext.productName)) {
      handleDirty();
    } else {
      handleChangeDirty();
    }
  };

  const handleCallCondition = (e) => {
    let ocrAddressEditFlag = false;
    if (ocrResponse) {
      if (
        e.target.name === 'address2' ||
        e.target.name === 'country' ||
        e.target.name === 'city' ||
        e.target.name === 'state' ||
        e.target.name === 'zipCode'
      ) {
        ocrAddressEditFlag = true;
        setAddressInformation((prevState) => ({
          ...prevState,
          ocrAddressEdit: ocrAddressEditFlag,
        }));
      }
    }
    if (e.target.name === 'utilityBill' && addressProofUploadStatus === DONE) {
      clearOCRdata(leadGenerationContext);
    }
    if (
      e.target.name === 'address2' ||
      e.target.name === 'country' ||
      e.target.name === 'city' ||
      e.target.name === 'state' ||
      e.target.name === 'zipCode'
    ) {
      handleAddressEditModal(leadGenerationContext);

      setAddressInformation((prevState) => ({ ...prevState, vouchedAddrEdited: true }));
    }
  };

  const handleChangeCall = (e) => {
    if (e.target.name === 'sameMailingAddress' && e.target.checked === true) {
      handleChangeMailing(e);
    } else if (e.target.name === 'sameMailingAddress' && e.target.checked === false) {
      handleChangeMailingAddress(e);
    } else if (e.target.name === 'address2' || e.target.name === 'permanentAddress2') {
      handleChangeAddresstwo(e);
    } else if (e.target.name === 'country' || e.target.name === 'permanentCountry') {
      handleChangeCountry(e);
    } else if (e.target.name === 'state' || e.target.name === 'permanentState') {
      handleChangeState(e);
    } else if (e.target.name === 'city' || e.target.name === 'permanentCity') {
      handleChangeCity(e);
    } else if (e.target.name === 'zipCode' || e.target.name === 'permanentZipCode') {
      handleChangeZipcode(e);
    } else if (e.target.name === 'utilityBill') {
      handleChangeBillType(e);
    }
  };

  const handleChange = (e) => {
    handleCallDirty();
    handleChangeCall(e);
    handleCallCondition(e);
  };

  const isAddressEdited = () => {
    const gifElem = document.getElementById('newAddrGIF');
    let gifElemStatus;
    if (gifElem) {
      gifElemStatus = true;
    } else {
      gifElemStatus = false;
    }
    return gifElemStatus;
  };

  const saveData = async () => {
    const dataObj = { ...addressInformation };
    let adrrFlag;
    if (
      dataObj.address1 ||
      dataObj.address2 ||
      dataObj.country ||
      dataObj.city ||
      dataObj.state ||
      dataObj.zipCode ||
      dataObj.permanentAddress1 ||
      dataObj.permanentAddress2 ||
      dataObj.permanentCountry ||
      dataObj.permanentState ||
      dataObj.permanentCity ||
      dataObj.permanentZipCode
    ) {
      adrrFlag = true;
    }
    dataObj.applicationId = leadGenerationContext.applicationId;
    dataObj.language = leadGenerationContext.language;
    dataObj.location = leadGenerationContext.location;
    dataObj.utmCampaign = leadGenerationContext.utmCampaign;
    dataObj.utmMedium = leadGenerationContext.utmMedium;
    dataObj.utmContent = leadGenerationContext.utmContent;
    dataObj.utmTerm = leadGenerationContext.utmTerm;
    dataObj.utmSource = leadGenerationContext.utmSource;
    dataObj.branchCode = leadGenerationContext.branchCode;
    dataObj.unverifiedIdAddressVouched = personalInformation?.unverifiedIdAddressVouched;
    dataObj.vouchedJobId = personalInformation?.vouchedJobId;
    dataObj.vouchedStatus = personalInformation?.vouchedStatus
      ? personalInformation.vouchedStatus
      : null;
    dataObj.vouchedTimestamp = personalInformation?.vouchedTimestamp
      ? personalInformation.vouchedTimestamp
      : null;
    dataObj.adrrFlag = adrrFlag;
    dataObj.ocrErrors = ocrErrorMessageArr;
    dataObj.currentAddressEdit = addressWithErrors;
    dataObj.vouchedCurrentAddressFlag = userOptionAddress === 'vouchedCurrentAddressFlag';

    dataObj.newAddressEdit = newAddress;
    dataObj.vouchedNewAddressFlag = userOptionAddress === 'vouchedNewAddressFlag';

    dataObj.vouchedAddressVerified = addressInformation.vouchedAddressVerified;
    dataObj.retainUtilityBill = addressInformation.retainUtilityBill;

    let response = null;
    response = await saveAddressInformation(dataObj, leadGenerationContext.accessToken);
    return response;
  };
  let valid = true;

  const handleIsFormValid = () => {
    if (!addressInformation?.permanentAddress1) {
      valid = false;
      setAddressInformationErrors((prevState) => ({
        ...prevState,
        permanentAddress1: MANDATORY_FIELD_ERR,
      }));
    }
    if (!addressInformation?.permanentCountry) {
      valid = false;
      setAddressInformationErrors((prevState) => ({
        ...prevState,
        permanentCountry: MANDATORY_FIELD_ERR,
      }));
    }
    if (!addressInformation?.permanentState) {
      valid = false;
      setAddressInformationErrors((prevState) => ({
        ...prevState,
        permanentState: MANDATORY_FIELD_ERR,
      }));
    }
    if (!addressInformation?.permanentCity) {
      valid = false;
      setAddressInformationErrors((prevState) => ({
        ...prevState,
        permanentCity: MANDATORY_FIELD_ERR,
      }));
    }
    if (!addressInformation?.permanentZipCode) {
      valid = false;
      setAddressInformationErrors((prevState) => ({
        ...prevState,
        permanentZipCode: MANDATORY_FIELD_ERR,
      }));
    }
  };

  /**
   * form HomeAddress fields mandatory check */
  const condition1 = () => {
    let valid1 = true;
    if (!addressInformation?.address1) {
      valid1 = false;
      setAddressInformationErrors((prevState) => ({ ...prevState, address1: MANDATORY_FIELD_ERR }));
    }
    return valid1;
  };

  const checkUtilityBillValid = () => {
    if (
      (productMapping(productName) || location === HOME_PR || dgiMapping(productName)) &&
      location !== HOME_VI
      // &&
      // addressInformation?.vouchedAddrEdited
    ) {
      if (!addressInformation?.utilityBill) {
        valid = false;
        setAddressInformationErrors((prevState) => ({
          ...prevState,
          utilityBill: MANDATORY_FIELD_ERR,
        }));
      }
    }
  };

  const isFormValid = () => {
    valid = condition1();
    if (!addressInformation?.country) {
      valid = false;
      setAddressInformationErrors((prevState) => ({ ...prevState, country: MANDATORY_FIELD_ERR }));
    }
    if (!addressInformation?.state) {
      valid = false;
      setAddressInformationErrors((prevState) => ({ ...prevState, state: MANDATORY_FIELD_ERR }));
    }
    if (!addressInformation?.city) {
      valid = false;
      setAddressInformationErrors((prevState) => ({ ...prevState, city: MANDATORY_FIELD_ERR }));
    }
    if (!addressInformation?.zipCode) {
      valid = false;
      setAddressInformationErrors((prevState) => ({ ...prevState, zipCode: MANDATORY_FIELD_ERR }));
    }
    if (newAddress || addressInformation.vouchedAddressVerified === false) {
      checkUtilityBillValid();
    }

    if (!addressInformation?.sameMailingAddress) {
      handleIsFormValid();
    }
    if (isAddressEdited() && !addressInformation.homeAddressUploadDocumentId && newAddress) {
      valid = false;
    }
    if (addressProofUploadStatus === FAILED) {
      valid = false;
    }
    for (const key in addressInformationErrors) {
      if (addressInformationErrors[key]) {
        valid = false;
        break;
      }
    }
    return valid;
  };
  /**
   * With successful save status 201, If the flow is DGI, will be routed to DGI Additional Info(Screen 4)
   * With successful save status 201, If the flow is account opening process, will be routed to compliance screen(Screen 4) */
  const handleSaveDate = (result) => {
    if (result && result.status === 201) {
      setIsValidating(false);
      setIsScreenThreeDirty(false);
      if (dgiMapping(leadGenerationContext.productName)) {
        history.push(
          `/${location?.toLowerCase()}/${language?.toLowerCase()}/retail-form/${productNameURLMapping(
            productName
          )}/dgiadditional-info`
        );
      } else {
        history.push(
          `/${location?.toLowerCase()}/${language?.toLowerCase()}/retail-form/${productNameURLMapping(
            productName
          )}/compliance-info`
        );
      }
    }
  };
  /**
   * Focus check for mandatory address fields */
  const handleFocusValid = () => {
    let fieldList;
    if (newAddress) {
      fieldList = ['utilityBill', 'address1', 'country', 'state', 'city', 'zipCode'];
    } else {
      fieldList = ['address1', 'country', 'state', 'city', 'zipCode'];
    }

    if (!addressInformation?.sameMailingAddress) {
      fieldList.push('permanentAddress1');
      fieldList.push('permanentCountry');
      fieldList.push('permanentState');
      fieldList.push('permanentCity');
      fieldList.push('permanentZipCode');
    }
    for (const field of fieldList) {
      if (!addressInformation[field]) {
        const element = document.getElementById(field);
        if (element) {
          element.focus();
          break;
        }
      }
    }
  };
  /**
   * Focus check for document upload icon if user fail to upload document */
  let isElementFound = false;
  const docFocus = () => {
    if (
      (isAddressEdited() && !addressInformation.homeAddressUploadDocumentId) ||
      addressProofUploadStatus === 'FAILED'
    ) {
      let elem;
      if (addressProofUploadStatus === 'DONE') {
        elem = 'uploadAddressProofSuccess';
      } else if (addressProofUploadStatus === 'FAILED') {
        elem = 'uploadAddressProofFail';
      } else {
        elem = 'uploadAddressProofInitial';
      }
      const element = document.getElementById(elem);
      if (element) {
        isElementFound = true;
        element.focus();
      }
    }
  };
  /**
   * Focus check for mandatory error address fields */
  const handlefocus = () => {
    let fields;
    if (newAddress || addressInformation.retainUtilityBill) {
      fields = ['utilityBill', 'address1', 'address2', 'country', 'state', 'city', 'zipCode'];
    } else {
      fields = ['address1', 'address2', 'country', 'state', 'city', 'zipCode'];
    }

    if (!addressInformation?.sameMailingAddress) {
      fields.push('permanentAddress1');
      fields.push('permanentAddress2');
      fields.push('permanentCountry');
      fields.push('permanentState');
      fields.push('permanentCity');
      fields.push('permanentZipCode');
    }

    docFocus();
    if (!isElementFound) {
      for (const field of fields) {
        if (addressInformationErrors[field]) {
          const element = document.getElementById(field);
          if (element) {
            isElementFound = true;
            element.focus();
            break;
          }
        }
      }
    }
    if (!isElementFound) {
      handleFocusValid();
    }

    setIsValidating(false);
  };
  /**
   * When there is no change of data(value change for the fields) on current screen then just routing has be done without save call.
   * DGI Additional Info in case of DGI flow
   * Compliance screen in case of account opeing process  */
  const handleSaveDataRoute = () => {
    setIsValidating(false);
    setIsScreenThreeDirty(false);
    if (dgiMapping(leadGenerationContext.productName)) {
      history.push(
        `/${location?.toLowerCase()}/${language?.toLowerCase()}/retail-form/${productNameURLMapping(
          productName
        )}/dgiadditional-info`
      );
    }
    //  else if (productName === 'Consumer Credit') {
    //   history.push(
    //     `/${location?.toLowerCase()}/${language?.toLowerCase()}/retail-form/${productNameURLMapping(
    //       productName
    //     )}/consumer-employment-info`
    //   );
    // }
    else {
      history.push(
        `/${location?.toLowerCase()}/${language?.toLowerCase()}/retail-form/${productNameURLMapping(
          productName
        )}/compliance-info`
      );
    }
  };
  const handleCondition = () => {
    setAddressInformation((prevState) => ({
      ...prevState,
      permanentAddress1: prevState?.address1 ? prevState.address1 : '',
      permanentAddress2: prevState?.address2 ? prevState.address2 : '',
      permanentCity: prevState?.city ? prevState.city : '',
      permanentCountry: prevState?.country,
      permanentState: prevState?.state,
      permanentZipCode: prevState?.zipCode ? prevState.zipCode : '',
    }));
    setAddressInformationErrors((prevState) => ({
      ...prevState,
      permanentAddress2: '',
      permanentAddress1: '',
      permanentCity: '',
      permanentCountry: '',
      permanentState: '',
      permanentZipCode: '',
    }));
  };

  /**
   * Handle Save Application button: Should be navigated to Save Application Page */
  const handleSaveApplication = (e) => {
    e.preventDefault();
    setIsModalSaveLater(true);
  };
  /**
   * Handle continue button */
  const handleContinue = async (e) => {
    e.preventDefault();
    setIsValidating(true);
    if (addressInformation?.sameMailingAddress) {
      handleCondition();
    }
    const isValid = isFormValid();
    if (isValid) {
      if (isScreenThreeDirty) {
        const result = await saveData();
        handleSaveDate(result);
      } else {
        handleSaveDataRoute();
      }
    } else {
      handlefocus();
    }
    setIsValidating(false);
  };
  /**
   * Handle back button: Should be navigated to personal information(screen 2) */
  const handleBack = (e) => {
    e.preventDefault();
    // setAddressInformation((prevState) => ({
    //   ...prevState,
    //   editHomeAddress: false,
    // }));
    setIsFullAddressEdited(false);
    history.push(
      `/${location?.toLowerCase()}/${language?.toLowerCase()}/retail-form/${productNameURLMapping(
        productName
      )}/personal-info`
    );
  };
  /**
   * set docId in addressInfo object when address document uploaded */
  const setHomeAddressUploadDocId = (docId) => {
    setIsScreenThreeDirty(true);
    setIsScreenFourDirty(true);
    setIsScreenFiveDirty(true);
    setIsFundingScreenDirty(true);
    setAddressInformation((prevState) => ({ ...prevState, homeAddressUploadDocumentId: docId }));
  };
  const toggleCheckboxOnEnter = (input) => {
    setIsScreenThreeDirty(true);
    setIsScreenFourDirty(true);
    setIsScreenFiveDirty(true);
    setIsFundingScreenDirty(true);
    const {
      address1,
      address2,
      country,
      city,
      state,
      zipCode,
      sameMailingAddress,
      defaultCountryBasedOnLocation,
    } = addressInformation;
    if (input === 'sameMailingAddress') {
      const currentState = sameMailingAddress;
      const toggledState = !currentState;
      const defaultCountry = defaultCountryBasedOnLocation;
      if (toggledState === false) {
        setAddressInformation((prevState) => ({
          ...prevState,
          [input]: toggledState,
          permanentAddress1: '',
          permanentAddress2: '',
          permanentCity: '',
          permanentCountry: defaultCountry || 'PR',
          permanentState: defaultCountry === 'VI' || defaultCountry === 'PR' ? 'N/A' : '',
          permanentZipCode: '',
        }));
      }
      if (toggledState === true) {
        setAddressInformation((prevState) => ({
          ...prevState,
          [input]: toggledState,
          permanentAddress1: commonUtility(address1),
          permanentAddress2: commonUtility(address2),
          permanentCity: commonUtility(city),
          permanentCountry: commonUtility(country),
          permanentState: commonUtility(state),
          permanentZipCode: commonUtility(zipCode),
        }));
        setAddressInformationErrors((prevState) => ({
          ...prevState,
          permanentAddress1: '',
          permanentAddress2: '',
          permanentCountry: '',
          permanentCity: '',
          permanentState: '',
          permanentZipCode: '',
        }));
      }
    }
  };

  // eslint-disable-next-line react/no-unstable-nested-components
  const oldLayout = () => (
    <Layout
      ariaDescribedby="screenThreeHeading"
      headingId="screenThreeHeading"
      ariaDescribedbyId="screenThreeDesc"
      classes={classes}
      descriptionKey={
        productMapping(productName) === 'Elite Account'
          ? 'Address Description Text Prog'
          : 'Address Description Text'
      }
      descriptionValue={
        productMapping(productName) === 'Elite Account' ? ADDRESS_INFO_HEAD_PROG : ADDRESS_INFO_HEAD
      }
      stepValue={1}
      handleBack={handleBack}
      handleContinue={handleContinue}
      disableCondition={isValidating || disableContinue}
      handleSaveApplication={handleSaveApplication}
      backBtnTestid="backBtn_id"
      continueBtnTestid="continue_testid"
      screenLoading={isValidating}
      layoutImage={
        productMapping(productName) === ELITE_ACCOUNT_EN || productMapping(productName) === 'Ahorra'
          ? EliteImage
          : RetailImage1
      }
    >
      <Box component="div" sx={classes.address_button_container} data-page="address-info">
        {/* Child components */}
        <Grid container>
          <Grid size={{ xs: 12 }}>
            <Typography
              data-testid="addrInfoTitle"
              sx={formHeadingInfo}
              variant="h2"
              aria-label={t(HOME_ADDRESS_TITLE, {
                defaultValue: HOME_ADDRESS_TITLE,
              })}
            >
              {productMapping(productName) === 'Elite Account'
                ? t('We’d love Prog', {
                    defaultValue: HOME_ADDRESS_TITLE_PROG,
                    nsSeparator: '|',
                  })
                : t(HOME_ADDRESS_TITLE, {
                    defaultValue: HOME_ADDRESS_TITLE,
                  })}
            </Typography>
          </Grid>
        </Grid>

        <Grid container style={{ display: 'flex' }}>
          <Grid size={{ xs: 12, sm: 12, md: 6 }} sx={classes.homeAddGrid}>
            <HomeAddress handleChange={handleChange} />
          </Grid>

          {newAddress ||
          addressInformation.vouchedAddressVerified === false ||
          addressInformation.retainUtilityBill === true ||
          (leadGenerationContext.savedDataFlow &&
            addressInformation.homeAddressUploadDocumentId) ? (
            <Grid
              role="section"
              aria-roledescription={t('Upload Home Address Proof', {
                defaultValue: 'Upload Home Address Proof',
              })}
              size={{ xs: 12, sm: 12, md: 6 }}
              sx={classes.docUploadSidebarGrid}
            >
              <DocumentUploadSidebar
                fileType="Home Address Proof"
                setHomeAddressUploadDocId={setHomeAddressUploadDocId}
                vouchedAddrEdited={addressInformation?.vouchedAddrEdited}
                pagePath="address-info"
              />
            </Grid>
          ) : (
            ''
          )}
        </Grid>

        <Box component="hr" sx={classes.horizontal_line} />
        <Grid container>
          <Grid size={{ xs: 12 }} sx={classes.mailing_address_box}>
            <Box component="div" sx={classes.mailing_address_text} data-testid="mailingTitle">
              {t(DIFFERENT_MAIL_ADDR, {
                defaultValue: DIFFERENT_MAIL_ADDR,
              })}
              <span style={tooltipStyle}>
                <CustomTooltip
                  customAriaLabel={t('Mailing Address Info', {
                    defaultValue: 'Mailing Address Info',
                  })}
                  text={t('Mailing Address Tooltip', { defaultValue: tooltipMailingText })}
                />
              </span>
            </Box>

            <Box
              sx={classes.togglePadding}
              role="application"
              aria-roledescription={t(DIFFERENT_MAIL_ADDR, {
                defaultValue: DIFFERENT_MAIL_ADDR,
              })}
            >
              <CustomSwitch
                isBundle={isBundle(productName)}
                id="sameMailingAddress"
                ariaLabelName={`${t(MAIL_HOME_ADDR_SAME, {
                  defaultValue: MAIL_HOME_ADDR_SAME,
                })}`}
                defaultData={!!addressInformation?.sameMailingAddress}
                ariaLabelledby="toggleone"
                handleClickCheckbox={handleChange}
                toggleCheckboxOnEnter={toggleCheckboxOnEnter}
                dataTestId="sameMailingCheckbox"
              />
            </Box>
          </Grid>
        </Grid>
        <Grid container>
          <Grid size={{ xs: 12, sm: 12, md: 6 }} sx={classes.homeAddGrid}>
            <MailingAddress handleChange={handleChange} />
          </Grid>
        </Grid>
      </Box>
    </Layout>
  );
  const shouldShowUtilityBillCard =
    ((productMapping(productName) || location === HOME_PR || dgiMapping(productName)) &&
      location !== HOME_VI &&
      newAddress) ||
    addressInformation.utilityBill ||
    (addressInformation.vouchedAddressVerified === false && location !== HOME_VI) ||
    addressInformation.retainUtilityBill === true;

  const isBundleProduct = isBundle(productName);

  const bundleLayout = () => (
    <NewLayout
      handleContinue={handleContinue}
      handleBack={handleBack}
      stepValue={1}
      // disableCondition={isValidating || disableContinue}
      handleSaveApplication={handleSaveApplication}
      backBtnTestid="backBtn_id"
      continueBtnTestid="continue_testid"
      screenLoading={isValidating}
    >
      <Grid container data-page="address-info">
        {!(isBundleProduct && shouldShowUtilityBillCard) && (
          <Grid
            size={{ sm: 12, xs: 12 }}
            width="100%"
            sx={{
              backgroundColor: theme?.palette?.success?.main,
              minHeight: '24px',
              padding: '20px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '15px 0',
              borderRadius: '6px',
              border: '1px solid #0B6C03',
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <GreenTick width="24" height="24" color={isLightTheme ? '#0B6C03' : '#FFF'} />

              <Typography
                variant="subtitle2"
                sx={{
                  color: isLightTheme ? '#0B6C03' : '#FFF',
                  fontWeight: 700,
                  marginLeft: '5px',
                }}
              >
                {t(VERIFICATION_COMPLETED, {
                  defaultValue: VERIFICATION_COMPLETED,
                })}
              </Typography>
            </Box>
          </Grid>
        )}
      </Grid>

      {!addressInformation?.editHomeAddress && addressInformation?.vouchedAddressVerified && (
        // addressInformation.vouchedAddressVerified === true &&

        <AddressInfo handleChange={handleChange} />
      )}
      {/* 
      {((productMapping(productName) || location === HOME_PR || dgiMapping(productName)) &&
        location !== HOME_VI &&
        newAddress) ||
        addressInformation.utilityBill ||
        (addressInformation.vouchedAddressVerified === false && location !== HOME_VI) ||
        (addressInformation.retainUtilityBill === true && (
          <BillTypeCustomCard handleChange={handleChange} />
        ))} */}
      {(addressInformation?.editHomeAddress || !addressInformation.address1) && (
        <>
          {!isBundle(productName) && (
            <Grid
              container
              sx={[layoutClasses.mailingAddressSwitchContainer, layoutClasses.fullWidth]}
            >
              <Grid size={{ xs: 10, sm: 10, md: 10, lg: 10 }} sx={layoutClasses.tooltipStyle}>
                <Typography component="p">
                  {isBundle(productName)
                    ? t(CHANGE_ADDRESS, {
                        defaultValue: CHANGE_ADDRESS,
                      })
                    : t('I wish to edit the home address', {
                        defaultValue: 'I wish to edit the home address',
                      })}
                </Typography>
              </Grid>

              <Grid size={{ xs: 2, sm: 2, md: 2, lg: 2 }} sx={layoutClasses.switchPosition}>
                <CustomSwitch
                  isBundle={isBundle(productName)}
                  id="editHomeAddress"
                  ariaLabelName={`${t('I wish to edit the home address', {
                    defaultValue: 'I wish to edit the home address',
                  })}`}
                  defaultData={!!addressInformation?.editHomeAddress}
                  ariaLabelledby="toggleone"
                  handleClickCheckbox={(e) => {
                    setAddressInformation((prevState) => ({
                      ...prevState,
                      editHomeAddress: !addressInformation?.editHomeAddress,
                    }));
                    setIsFullAddressEdited(false);
                    setPopupModalIntial(true);
                  }}
                  // toggleCheckboxOnEnter={toggleCheckboxOnEnter}
                  dataTestId="editHomeAddress_testId"
                />
              </Grid>
            </Grid>
          )}

          <Grid container>
            <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
              {newAddress ||
              addressInformation.vouchedAddressVerified === false ||
              addressInformation.retainUtilityBill === true ||
              (leadGenerationContext.savedDataFlow &&
                addressInformation.homeAddressUploadDocumentId &&
                addressInformation.utilityBill) ? (
                <DocumentUploadSidebar
                  fileType="Home Address Proof"
                  setHomeAddressUploadDocId={setHomeAddressUploadDocId}
                  vouchedAddrEdited={addressInformation?.vouchedAddrEdited}
                  pagePath="address-info"
                  isBundleFlag
                  handleChange={handleChange}
                />
              ) : (
                ''
              )}
            </Grid>
          </Grid>

          {(!addressInformation.vouchedAddressVerified || addressInformation.editHomeAddress) && (
            <HomeAddress handleChange={handleChange} isBundle />
          )}
        </>
      )}
      <Grid container sx={[layoutClasses.mailingAddressSwitchContainer, layoutClasses.fullWidth]}>
        <Grid size={{ xs: 10, sm: 10, md: 10, lg: 10 }} sx={layoutClasses.tooltipStyle}>
          <Typography component="p" variant="subtitle1">
            {t(MAIL_ADDRESS, {
              defaultValue: MAIL_ADDRESS,
            })}
          </Typography>
          &ensp;
          {!isBundle && (
            <CustomTooltip
              customAriaLabel={t('Mailing Address Info', {
                defaultValue: 'Mailing Address Info',
              })}
              text={t('Mailing Address Tooltip', { defaultValue: 'Mailing Address Tooltip' })}
            />
          )}
        </Grid>

        <Grid size={{ xs: 2, sm: 2, md: 2, lg: 2 }} sx={layoutClasses.switchPosition}>
          <CustomSwitch
            isBundle={isBundle(productName)}
            id="sameMailingAddress"
            ariaLabelName={`${t(MAIL_HOME_ADDR_SAME, {
              defaultValue: MAIL_HOME_ADDR_SAME,
            })}`}
            defaultData={!!addressInformation?.sameMailingAddress}
            ariaLabelledby="toggleone"
            handleClickCheckbox={handleChange}
            toggleCheckboxOnEnter={toggleCheckboxOnEnter}
            dataTestId="sameMailingCheckbox"
          />
        </Grid>
      </Grid>
      <Grid container>
        <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12 }} sx={classes.homeAddGrid}>
          <MailingAddress handleChange={handleChange} />
        </Grid>
      </Grid>
    </NewLayout>
  );
  const addressInfoJsx = commonTernary(isBundle(productName), bundleLayout(), oldLayout());
  return (
    /**
     * AddressInformation screen 3 product name and heading JSX content */
    <>
      {addressInfoJsx}
      {vouchedFailModal && (
        <CommercialModal
          message={t(`MSG_VOUCHED_MODAL`, { defaultValue: MSG_VOUCHED_MODAL })}
          vouchedModal
          openModal={vouchedFailModal}
        />
      )}
      <AddressEditModal
        setIsModal={setAddressEditQuestionModal}
        openModal={addressEditQuestionModal}
      />
      {isModalSaveLater && (
        <SaveAppContactInfo openModal={isModalSaveLater} currentPage="address-info" />
      )}
    </>
  );
};

export default withRouter(AddressInformation);
AddressInformation.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func,
  }),
};
